import { composeAgencyContextMarkdownDocument } from '@apps/web/components/settings/use_agency_context_editor';
import { Markdown } from '@apps/web/components/ui/markdown';
import { useAgencyContext } from '@apps/web/swr_data_fetching/data_fetching_hooks';

/**
 * The organization's agency context as it stands.
 *
 * Shows the whole document rather than only the fact this note wrote, so the
 * card matches what Settings → Agency context shows.
 */
export function AgencyContextPreview({
    organizationId,
    fallbackText,
}: {
    readonly organizationId: string | null;
    readonly fallbackText: string;
}) {
    const { data, isLoading } = useAgencyContext({
        organizationId,
        enabled: true,
    });
    const text = data?.text ?? '';

    if (text === '') {
        return (
            <p className="text-muted-foreground text-xs leading-4">
                {isLoading
                    ? 'Loading…'
                    : fallbackText ||
                      'Phoebe has no agency details recorded yet.'}
            </p>
        );
    }

    return (
        <Markdown className="text-foreground/85 text-xs leading-4">
            {composeAgencyContextMarkdownDocument(text)}
        </Markdown>
    );
}
